export const ANIMATION_DURATION = 300;

export const USER_ASSIGNMENT_STATUS = {
  ALL_ASSIGNED: 'ALL_ASSIGNED',
  NONE_ASSIGNED: 'NONE_ASSIGNED',
  PARTIALLY_ASSIGNED: 'PARTIALLY_ASSIGNED',
} as const;

export type UserAssignmentStatus =
  (typeof USER_ASSIGNMENT_STATUS)[keyof typeof USER_ASSIGNMENT_STATUS];
